<template>
  <NuxtLayout :name="layout">
    <NuxtPage />
  </NuxtLayout>
</template>

<script>
import { isIndonesia } from "@/utils/language";

export default {
  setup() {
    const config = useRuntimeConfig();
    const siteUrl = config.public.siteUrl;
    const gtagMeasurementId = config.public.gtagMeasurementId;
    const gtmId = config.public.gtmId;

    useHead({
      title: "PT Salam Pacific Indonesia Lines",
      titleTemplate: (titleChunk) => {
        if (!titleChunk) {
          return "PT Salam Pacific Indonesia Lines";
        }
        if (
          titleChunk === "SPIL | PT Salam Pacific Indonesia Lines" ||
          titleChunk === "PT Salam Pacific Indonesia Lines" ||
          titleChunk === "SPIL"
        ) {
          return "PT Salam Pacific Indonesia Lines";
        }
        if (
          titleChunk.endsWith("| PT Salam Pacific Indonesia Lines") ||
          titleChunk.endsWith("| SPIL") ||
          titleChunk.endsWith("- SPIL")
        ) {
          return titleChunk;
        }
        return `${titleChunk} | PT Salam Pacific Indonesia Lines`;
      },
      htmlAttrs: () => ({
        lang: isIndonesia() ? "id" : "en",
      }),
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { "http-equiv": "X-UA-Compatible", content: "IE=edge" },

        // Google / Search Engine
        {
          name: "description",
          content:
            "PT SPIL (Salam Pacific Indonesia Lines) menyajikan layanan shipping & logistik (shiplog) satu atap dengan kepastian jadwal dan berbagai kemudahan pengiriman barang.",
        },
        {
          itemprop: "name",
          content: "SPIL | PT Salam Pacific Indonesia Lines",
        },
        {
          itemprop: "description",
          content:
            "PT SPIL (Salam Pacific Indonesia Lines) menyajikan layanan shipping & logistik (shiplog) satu atap dengan kepastian jadwal dan berbagai kemudahan pengiriman barang.",
        },
        {
          itemprop: "image",
          content: `${siteUrl}/spil_sosmedshare.webp`,
        },

        // Open Graph / LinkedIn / Facebook
        { property: "og:url", content: `${siteUrl}/` },
        { property: "og:type", content: "website" },
        { property: "og:site_name", content: "SPIL" },
        {
          property: "og:title",
          content: "SPIL | PT Salam Pacific Indonesia Lines",
        },
        {
          property: "og:description",
          content:
            "PT SPIL (Salam Pacific Indonesia Lines) menyajikan layanan shipping & logistik (shiplog) satu atap dengan kepastian jadwal dan berbagai kemudahan pengiriman barang.",
        },
        {
          property: "og:image",
          content: `${siteUrl}/spil_sosmedshare.webp`,
        },
        {
          property: "og:image:alt",
          content: "PT Salam Pacific Indonesia Lines",
        },

        // Twitter / X
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:site", content: "@ptspil" },
        {
          name: "twitter:title",
          content: "SPIL | PT Salam Pacific Indonesia Lines",
        },
        {
          name: "twitter:description",
          content:
            "PT SPIL (Salam Pacific Indonesia Lines) menyajikan layanan shipping & logistik (shiplog) satu atap dengan kepastian jadwal dan berbagai kemudahan pengiriman barang.",
        },
        {
          name: "twitter:image",
          content: `${siteUrl}/spil_sosmedshare.webp`,
        },
        {
          name: "twitter:image:alt",
          content: "PT Salam Pacific Indonesia Lines",
        },
      ],
      link: [
        { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
        { rel: "preconnect", href: "https://www.spil.co.id" },
        { rel: "icon", type: "image/svg+xml", href: "/spil_logo.svg" },
        { rel: "icon", type: "image/png", href: "/spil_logo.png" },
      ],
      script: [
        {
          innerHTML: `
        (function() {
          function loadAnalytics() {
            var g = document.createElement('script'); g.async = true;
            g.src = 'https://www.googletagmanager.com/gtag/js?id=${gtagMeasurementId}';
            document.head.appendChild(g);

            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gtagMeasurementId}');

            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');
          }

          if (document.readyState === 'complete') {
            setTimeout(loadAnalytics, 1500);
          } else {
            window.addEventListener('load', function() { setTimeout(loadAnalytics, 1500); });
          }
        })();
      `,
          tagPosition: "bodyClose",
        },
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Corporation",
            name: "SPIL",
            url: `${siteUrl}/`,
            logo: `${siteUrl}/img/spil_logo.581f4306.svg`,
            sameAs: [
              "https://www.facebook.com/ptspil/",
              "https://www.instagram.com/ptspil/",
              "https://www.linkedin.com/company/pt-salam-pacific-indonesia-lines/",
            ],
          }),
        },
      ],
      noscript: [
        {
          innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-56RQSC7H"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        },
      ],
    });
  },
  computed: {
    layout() {
      const route = useRoute();
      return route.meta.layout || "default";
    },
  },
};
</script>
